function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-57.579 2.308)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M366.6,206.142h1.2l0-40.85c.089-9.124,5.424-13.376,11.825-13.642l84.956-.133c5.068.266,10.492,4.163,10.492,13.465l-.141,206.069c-.149,2.994-2.988,10.33-10.607,10.294H379.907c-7.171-.114-12.4-5.054-12.4-13.138l.288-137.442h-1.2Z",
  transform: "translate(-309.021 -153.824)",
  fill: "#222d3c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M412.7,95.605V301.373a9.25,9.25,0,0,1-9.247,9.241H319.918a9.231,9.231,0,0,1-9.247-9.241V95.605a9.247,9.247,0,0,1,9.248-9.247h12.5v1.6a7.615,7.615,0,0,0,7.613,7.616h42.486a7.552,7.552,0,0,0,4.514-1.486,7.075,7.075,0,0,0,.749-.629,7.592,7.592,0,0,0,2.349-5.5v-1.6h13.323a9.244,9.244,0,0,1,9.247,9.247Z",
  transform: "translate(-249.343 -86.066)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.222,
  cy: 2.222,
  r: 2.222,
  transform: "translate(82.377 32.354)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M551.97,108.738a7.081,7.081,0,0,1-.749.629,39.759,39.759,0,0,0,25.669,19.107v-.99A38.823,38.823,0,0,1,551.97,108.738Z",
  transform: "translate(-413.532 -101.342)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M491.532,115.4h-1.041a57.67,57.67,0,0,0,44.947,35.887V150.3A56.68,56.68,0,0,1,491.532,115.4Z",
  transform: "translate(-372.08 -105.888)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M431.194,115.4h-1a76.038,76.038,0,0,0,64.089,54.321v-.968A75.071,75.071,0,0,1,431.194,115.4Z",
  transform: "translate(-330.922 -105.888)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M263.7,158.578h-.578V158H263v.578h-.579v.113H263v.578h.113v-.578h.578Z",
  transform: "translate(-186.398 -107.552)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M386.7,67.578h-.578V67H386v.578h-.579v.113H386v.578h.113v-.578h.578Z",
  transform: "translate(-270.352 -45.439)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M281.7,230.578h-.578V230H281v.578h-.579v.113H281v.578h.113v-.578h.578Z",
  transform: "translate(-198.684 -156.696)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M365.7,177.578h-.578V177H365v.578h-.579v.113H365v.578h.113v-.578h.578Z",
  transform: "translate(-256.018 -120.521)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M485.7,210.578h-.578V210H485v.578h-.579v.113H485v.578h.113v-.578h.578Z",
  transform: "translate(-337.925 -143.045)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.27,
  cy: 1.27,
  r: 1.27,
  transform: "translate(139.835 38.703)",
  fill: "#ff6584"
}), /*#__PURE__*/React.createElement("path", {
  d: "M417.132,305.158l-.721.111c.225,1.441.4,2.914.533,4.371l.727-.063C417.541,308.1,417.36,306.615,417.132,305.158Z",
  transform: "translate(-321.517 -235.409)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M410.969,277.818l-.7.213c.422,1.4.8,2.828,1.121,4.254l.714-.162C411.779,280.681,411.395,279.234,410.969,277.818Z",
  transform: "translate(-317.326 -216.748)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M401.134,251.6l-.663.3c.609,1.33,1.181,2.7,1.7,4.06l.682-.257C402.328,254.325,401.754,252.941,401.134,251.6Z",
  transform: "translate(-310.637 -198.852)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M387.837,227.018l-.616.39c.784,1.232,1.536,2.508,2.235,3.787l.641-.349C389.392,229.551,388.63,228.262,387.837,227.018Z",
  transform: "translate(-301.593 -182.074)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M371.307,204.488l-.556.473c.946,1.111,1.867,2.273,2.736,3.447l.584-.435C373.2,206.786,372.265,205.612,371.307,204.488Z",
  transform: "translate(-290.351 -166.697)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M351.877,184.428l-.486.543c1.092.975,2.162,2,3.181,3.044l.524-.511C354.064,186.447,352.981,185.412,351.877,184.428Z",
  transform: "translate(-277.137 -153.004)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M329.921,167.208l-.41.6c1.213.816,2.413,1.686,3.565,2.584l.451-.575C332.358,168.913,331.146,168.033,329.921,167.208Z",
  transform: "translate(-262.203 -141.251)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M310.671,155.248v.825c.759.4,1.511.813,2.247,1.238l.365-.632Q312,155.937,310.671,155.248Z",
  transform: "translate(-249.343 -133.087)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M418.161,516.53c.118-.71.227-1.435.322-2.154l.724.1c-.1.727-.206,1.46-.326,2.178Z",
  transform: "translate(-322.711 -378.212)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M411.752,539.01l.7.217c.438-1.411.834-2.856,1.177-4.3l-.711-.168C412.576,536.188,412.187,537.615,411.752,539.01Z",
  transform: "translate(-318.337 -392.128)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M401.71,565.274l.662.31c.63-1.336,1.219-2.712,1.754-4.09l-.681-.266C402.917,562.592,402.333,563.953,401.71,565.274Z",
  transform: "translate(-311.482 -410.192)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M388.2,590.095l.612.4c.807-1.238,1.582-2.521,2.3-3.812l-.637-.357C389.766,587.6,389,588.868,388.2,590.095Z",
  transform: "translate(-302.26 -427.319)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M371.482,612.988l.553.479c.971-1.12,1.913-2.285,2.805-3.463l-.585-.437C373.376,610.732,372.444,611.882,371.482,612.988Z",
  transform: "translate(-290.85 -443.185)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M351.907,633.51l.481.549c1.116-.974,2.208-2,3.251-3.045l-.516-.517C354.091,631.53,353.009,632.543,351.907,633.51Z",
  transform: "translate(-277.489 -457.471)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M329.855,651.3l.4.611c1.233-.814,2.457-1.681,3.631-2.575l-.441-.583C332.285,649.642,331.076,650.5,329.855,651.3Z",
  transform: "translate(-262.437 -469.934)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M313.366,664.65c-.883.5-1.784.981-2.7,1.438v-.819c.787-.4,1.568-.822,2.333-1.251Z",
  transform: "translate(-249.343 -480.351)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M418.836,333.436l.73-.013c.013.737.014,1.478,0,2.2l-.73-.011C418.85,334.9,418.849,334.164,418.836,333.436Z",
  transform: "translate(-323.172 -254.701)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39.646,
  cy: 39.646,
  r: 39.646,
  transform: "translate(73.378 75.567)",
  fill: "#6c63ff",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27.92,
  cy: 27.92,
  r: 27.92,
  transform: "translate(85.104 87.294)",
  fill: "#6c63ff",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18.427,
  cy: 18.427,
  r: 18.427,
  transform: "translate(94.597 96.786)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.4,118.36a.794.794,0,0,1,.632-.187.829.829,0,0,1,.575.316.873.873,0,0,1-.129,1.222,10.291,10.291,0,0,1-16.124-4.527H90.308a.819.819,0,0,1-.6-.244.842.842,0,0,1-.259-.618.884.884,0,0,1,.863-.863H92.9a11.067,11.067,0,0,1-.144-1.767,10.12,10.12,0,0,1,.316-2.515h-2.52a.884.884,0,0,1-.862-.862.842.842,0,0,1,.259-.618.819.819,0,0,1,.6-.245h3.123a10.259,10.259,0,0,1,9.355-6.035,10.04,10.04,0,0,1,6.366,2.2.87.87,0,0,1-1.077,1.365,8.51,8.51,0,0,0-9.628-.647,8.355,8.355,0,0,0-3.076,3.118h4.3a.836.836,0,0,1,.862.863.819.819,0,0,1-.244.6.844.844,0,0,1-.618.259H94.853a8.558,8.558,0,0,0-.373,2.515,8.456,8.456,0,0,0,.187,1.767h4.165a.847.847,0,0,1,.618.259.822.822,0,0,1,.244.6.836.836,0,0,1-.863.862h-3.6A8.546,8.546,0,0,0,108.4,118.36Z",
  transform: "translate(10.052 3.514)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-114.813 -237.801)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M710.519,420.725v13.658s1.093,15.3,7.1,22.945c0,0,9.834,13.931,11.2,10.926l-1.682-9.892-5.693-5.4-3-16.936-.819-15.3Z",
  transform: "translate(-428.95 -103.842)",
  fill: "#ffb8b8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.828,524.941v10.107l-8.195,3V526.307Z",
  transform: "translate(-327.89 -84.59)",
  fill: "#ffb8b8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M639.219,522.609l5.463,12.292-7.648,3.278L635.4,526.16Z",
  transform: "translate(-313.945 -83.35)",
  fill: "#ffb8b8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M784.6,472.2s10.926,98.611,6.829,98.884-12.019,5.463-12.019,1.912-6.283-49.715-6.283-49.715l-6.009-23.765V532.3l6.283,37.15s-6.009,7.922-10.38,3.278l-9.287-36.33s-12.292-55.179-11.746-59.549C741.984,476.845,770.12,452.807,784.6,472.2Z",
  transform: "translate(-445.664 -127.183)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M823.648,704s2.185-4.644,7.1-1.639l4.1,4.917s10.564,8.748,3.068,10.622c-7.726,1.932-12.355-.123-12.355-.123a5.973,5.973,0,0,0-2.458-.82c-1.093,0-3.551-1.912-3.551-2.458s.819-10.226.819-10.226a1.722,1.722,0,0,1,1.912.273C823.1,705.363,823.648,704,823.648,704Z",
  transform: "translate(-486.901 -252.993)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M787.388,701.613s5.19-4.1,7.648.546c0,0,1.548.546,1.73,0s1.548-.819,1.548,2.185,1.483,10.5.118,10.772-2.732,1.093-2.458,2.185-1.483,1.247-7.766.974-6.556-2.732-6.556-2.732,0-3.551,1.639-5.463S787.388,701.613,787.388,701.613Z",
  transform: "translate(-466.757 -252.247)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M754.356,321.605s-1.366,10.107,7.375,13.658-19.394,15.3-22.126,8.468.546-9.014.546-9.014,2.732-2.732.273-10.107Z",
  transform: "translate(-443.831 -51.159)",
  fill: "#ffb8b8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.019,
  cy: 12.019,
  r: 12.019,
  transform: "translate(289.764 253.51)",
  fill: "#ffb8b8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M756.439,357.755s-8.195,4.371-16.116,1.093-7.648,10.926-7.648,10.926l4.1,10.653L765.18,377.7l-1.912-16.39Z",
  transform: "translate(-440.725 -70.373)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M739.353,337.8a9.916,9.916,0,0,1,6.8,5.249l13.112,4.1,3.278,4.644-3.824,33.6s7.1,6.829,7.1,10.653,8.741,16.936,4.37,15.3-12.292-7.375-12.292-7.375-19.941.819-26.223,6.283-8.741,3.824-8.741,3.824-6.556-28.409-6.829-32.779-7.922-30.594-7.922-30.594l13.658-7.648,3.479-3.947,9.633,15.42,8.741-10.653S739.379,340.476,739.353,337.8Z",
  transform: "translate(-427.711 -59.769)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M823.664,412.562,825.3,421.3s7.375,27.316,6.283,36.6c0,0,.819,20.76-3.824,18.3s-2.185-17.482-2.185-17.482l-6.556-27.043-3.551-15.843Z",
  transform: "translate(-484.731 -99.503)",
  fill: "#ffb8b8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M815.6,364.168l2.732,1.639s10.38,21.58,7.922,23.219-13.111,5.19-13.111,5.19Z",
  transform: "translate(-483.492 -73.782)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.943,205.855l-6.419-.137-.673,2.426.673,26.9,10.244,1.952Z",
  transform: "translate(-265.911 85.078)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M745.213,281.482l2.166-.788s-4.53-4.53-10.832-4.136l1.773-1.772s-4.333-1.576-8.272,2.56a35.187,35.187,0,0,0-5.96,7.608h-2.32l.968,1.937-3.389,1.937,3.479-.348a9.773,9.773,0,0,0,.329,5.016l.788,2.166s3.151-6.3,3.151-7.09v1.969s2.166-1.773,2.166-2.954l1.182,1.379.591-2.166,7.287,2.166-1.182-1.772,4.53.591-1.773-2.166s5.121,2.56,5.318,4.727a18.277,18.277,0,0,0,1.549,4.99l1.639-1.912S750.924,284.437,745.213,281.482Z",
  transform: "translate(-433.642 -26.118)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 0.956,
  cy: 2.458,
  rx: 0.956,
  ry: 2.458,
  transform: "translate(310.934 263.207)",
  fill: "#ffb8b8"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-176.824 33.149) rotate(-45)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M103.742,24.227c-.636,0-2,.034-2.244.07-2.7.544-4.6,3.532-4.634,6.708,0,2.908,1.68,6.306,4.735,6.748a19.608,19.608,0,0,0,2.208,0C108.071,37.261,103.742,24.227,103.742,24.227Z",
  transform: "translate(67.695 170.073)",
  fill: "#635aea"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 5.749,
  cy: 6.764,
  rx: 5.749,
  ry: 6.764,
  transform: "translate(165.551 194.304)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.505,107.391a.238.238,0,0,1,.2-.066.26.26,0,0,1,.184.112.309.309,0,0,1,.06.223.3.3,0,0,1-.1.208,3.046,3.046,0,0,1-3.969.126,3.543,3.543,0,0,1-1.185-1.723h-.975a.25.25,0,0,1-.193-.086.313.313,0,0,1-.083-.218.3.3,0,0,1,.083-.213.245.245,0,0,1,.193-.091h.828a4.3,4.3,0,0,1-.046-.623,3.918,3.918,0,0,1,.1-.887H89.8a.244.244,0,0,1-.193-.091.3.3,0,0,1-.083-.213.313.313,0,0,1,.083-.218.25.25,0,0,1,.193-.086h1a3.506,3.506,0,0,1,1.19-1.535,3.046,3.046,0,0,1,3.836.182.318.318,0,0,1,.1.2.329.329,0,0,1-.055.228.273.273,0,0,1-.184.112.259.259,0,0,1-.207-.061,2.515,2.515,0,0,0-3.078-.228,2.83,2.83,0,0,0-.983,1.1h1.373a.264.264,0,0,1,.2.086.324.324,0,0,1,.078.218.3.3,0,0,1-.078.213.258.258,0,0,1-.2.091H91.174a3.325,3.325,0,0,0-.06,1.51h1.331a.259.259,0,0,1,.2.091.306.306,0,0,1,.078.213.324.324,0,0,1-.078.218.264.264,0,0,1-.2.086H91.293a2.882,2.882,0,0,0,.992,1.287,2.485,2.485,0,0,0,1.5.5A2.516,2.516,0,0,0,95.505,107.391Z",
  transform: "translate(77.892 96.026)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(149.444 -238.662) rotate(45)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M107.073,24.227c-.943,0-2.971.045-3.33.093-4,.73-6.821,4.738-6.878,9-.006,3.9,2.493,8.459,7.028,9.052a32.2,32.2,0,0,0,3.278,0C113.5,41.711,107.073,24.227,107.073,24.227Z",
  transform: "translate(67.695 170.073)",
  fill: "#635aea"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.342,
  cy: 9.073,
  rx: 8.342,
  ry: 9.073,
  transform: "translate(165.889 194.305)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.748,109.431a.4.4,0,0,1,.31-.088.411.411,0,0,1,.282.15.4.4,0,0,1-.063.578,5.2,5.2,0,0,1-6.092.17,4.8,4.8,0,0,1-1.819-2.311h-1.5a.41.41,0,0,1-.3-.116.391.391,0,0,1-.127-.292.371.371,0,0,1,.127-.286.4.4,0,0,1,.3-.122H91.14a5.05,5.05,0,0,1-.071-.836,4.624,4.624,0,0,1,.155-1.19H89.988a.4.4,0,0,1-.3-.122.37.37,0,0,1-.127-.285.391.391,0,0,1,.127-.292.41.41,0,0,1,.3-.116H91.52a4.851,4.851,0,0,1,1.826-2.06,5.207,5.207,0,0,1,5.888.245.409.409,0,0,1,.155.272.4.4,0,0,1-.085.306.432.432,0,0,1-.282.15.439.439,0,0,1-.317-.082,4.3,4.3,0,0,0-4.724-.306,4.026,4.026,0,0,0-1.509,1.475h2.108a.435.435,0,0,1,.3.116.4.4,0,0,1,.12.292.38.38,0,0,1-.12.285.422.422,0,0,1-.3.122H92.1a3.912,3.912,0,0,0-.183,1.19,3.861,3.861,0,0,0,.092.836h2.044a.423.423,0,0,1,.3.122.382.382,0,0,1,.12.286.4.4,0,0,1-.12.292.435.435,0,0,1-.3.116H92.282a3.984,3.984,0,0,0,1.523,1.726,4.306,4.306,0,0,0,4.943-.224Z",
  transform: "translate(78.84 97.098)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-95.381 77.796) rotate(-28)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M100.85,24.227c-.368,0-1.16.018-1.3.036a3.547,3.547,0,0,0-2.685,3.513,3.455,3.455,0,0,0,2.744,3.534,12.573,12.573,0,0,0,1.28,0C103.359,31.053,100.85,24.227,100.85,24.227Z",
  transform: "translate(67.695 170.073)",
  fill: "#635aea"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 3.257,
  cy: 3.543,
  rx: 3.257,
  ry: 3.543,
  transform: "translate(165.079 194.302)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.077,104.546a.156.156,0,0,1,.121-.034.16.16,0,0,1,.11.058.157.157,0,0,1-.025.226,2.029,2.029,0,0,1-2.379.066,1.873,1.873,0,0,1-.71-.9H89.61a.16.16,0,0,1-.116-.045.153.153,0,0,1-.05-.114.145.145,0,0,1,.05-.112.156.156,0,0,1,.116-.048h.5a1.972,1.972,0,0,1-.028-.326,1.806,1.806,0,0,1,.061-.464h-.483a.155.155,0,0,1-.116-.048.145.145,0,0,1-.05-.111.153.153,0,0,1,.05-.114.16.16,0,0,1,.116-.045h.6a1.894,1.894,0,0,1,.713-.8,2.033,2.033,0,0,1,2.3.1.16.16,0,0,1,.061.106.156.156,0,0,1-.033.119.169.169,0,0,1-.11.059.171.171,0,0,1-.124-.032,1.68,1.68,0,0,0-1.845-.119,1.572,1.572,0,0,0-.589.576h.823a.17.17,0,0,1,.118.045.157.157,0,0,1,.047.114.149.149,0,0,1-.047.111.165.165,0,0,1-.118.048h-.969a1.528,1.528,0,0,0-.072.464,1.508,1.508,0,0,0,.036.326h.8a.165.165,0,0,1,.118.048.149.149,0,0,1,.047.112.157.157,0,0,1-.047.114.17.17,0,0,1-.118.045h-.691a1.556,1.556,0,0,0,.595.674,1.681,1.681,0,0,0,1.93-.088Z",
  transform: "translate(76.569 94.529)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-143.381 68.225) rotate(-28)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M100.85,24.227c-.368,0-1.16.018-1.3.036a3.547,3.547,0,0,0-2.685,3.513,3.455,3.455,0,0,0,2.744,3.534,12.573,12.573,0,0,0,1.28,0C103.359,31.053,100.85,24.227,100.85,24.227Z",
  transform: "translate(67.695 170.073)",
  fill: "#635aea"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 3.257,
  cy: 3.543,
  rx: 3.257,
  ry: 3.543,
  transform: "translate(165.079 194.302)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.077,104.546a.156.156,0,0,1,.121-.034.16.16,0,0,1,.11.058.157.157,0,0,1-.025.226,2.029,2.029,0,0,1-2.379.066,1.873,1.873,0,0,1-.71-.9H89.61a.16.16,0,0,1-.116-.045.153.153,0,0,1-.05-.114.145.145,0,0,1,.05-.112.156.156,0,0,1,.116-.048h.5a1.972,1.972,0,0,1-.028-.326,1.806,1.806,0,0,1,.061-.464h-.483a.155.155,0,0,1-.116-.048.145.145,0,0,1-.05-.111.153.153,0,0,1,.05-.114.16.16,0,0,1,.116-.045h.6a1.894,1.894,0,0,1,.713-.8,2.033,2.033,0,0,1,2.3.1.16.16,0,0,1,.061.106.156.156,0,0,1-.033.119.169.169,0,0,1-.11.059.171.171,0,0,1-.124-.032,1.68,1.68,0,0,0-1.845-.119,1.572,1.572,0,0,0-.589.576h.823a.17.17,0,0,1,.118.045.157.157,0,0,1,.047.114.149.149,0,0,1-.047.111.165.165,0,0,1-.118.048h-.969a1.528,1.528,0,0,0-.072.464,1.508,1.508,0,0,0,.036.326h.8a.165.165,0,0,1,.118.048.149.149,0,0,1,.047.112.157.157,0,0,1-.047.114.17.17,0,0,1-.118.045h-.691a1.556,1.556,0,0,0,.595.674,1.681,1.681,0,0,0,1.93-.088Z",
  transform: "translate(76.569 94.529)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-82.755 5.848) rotate(-1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M105.735,24.227c-.82,0-2.581.039-2.894.081-3.479.635-5.928,4.118-5.976,7.819,0,3.39,2.166,7.351,6.107,7.866a27.981,27.981,0,0,0,2.848,0C111.319,39.42,105.735,24.227,105.735,24.227Z",
  transform: "translate(67.695 170.073)",
  fill: "#635aea"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.249,
  cy: 7.885,
  rx: 7.249,
  ry: 7.885,
  transform: "translate(165.715 194.304)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.529,108.381a.347.347,0,0,1,.269-.077.357.357,0,0,1,.245.13.35.35,0,0,1-.055.5,4.516,4.516,0,0,1-5.294.147,4.169,4.169,0,0,1-1.581-2.008h-1.3a.356.356,0,0,1-.257-.1.34.34,0,0,1-.11-.254.323.323,0,0,1,.11-.248.347.347,0,0,1,.257-.106h1.1a4.39,4.39,0,0,1-.061-.726,4.019,4.019,0,0,1,.135-1.034H89.917a.346.346,0,0,1-.257-.106.322.322,0,0,1-.11-.248.34.34,0,0,1,.11-.254.356.356,0,0,1,.257-.1h1.332a4.216,4.216,0,0,1,1.587-1.79,4.525,4.525,0,0,1,5.116.213.356.356,0,0,1,.135.236.347.347,0,0,1-.074.266.375.375,0,0,1-.245.13.381.381,0,0,1-.276-.071,3.74,3.74,0,0,0-4.105-.266,3.5,3.5,0,0,0-1.311,1.282h1.832a.378.378,0,0,1,.264.1.35.35,0,0,1,.1.254.331.331,0,0,1-.1.248.367.367,0,0,1-.264.106H91.751a3.4,3.4,0,0,0-.159,1.034,3.356,3.356,0,0,0,.08.726h1.776a.368.368,0,0,1,.264.106.332.332,0,0,1,.1.248.35.35,0,0,1-.1.254.378.378,0,0,1-.264.1H91.91a3.462,3.462,0,0,0,1.324,1.5,3.741,3.741,0,0,0,4.3-.195Z",
  transform: "translate(78.352 96.546)",
  fill: "#fff"
})));

var SvgRentalDraw = function SvgRentalDraw(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181.31,
    height: 230.653,
    viewBox: "0 0 181.31 230.653",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRentalDraw, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Rental-draw.042a55f1.svg";
export { ForwardRef as ReactComponent };